import TradeInProvider from 'trade-in/TradeInProvider.jsx';
import TradeInWrapper from 'trade-in/components/TradeInWrapper/TradeInWrapper.jsx';
import InstantEstimateProvider from 'trade-in/InstantEstimateProvider.jsx';
import OfficialTradeInProvider from 'trade-in/OfficialTradeInProvider.jsx';
import TradeInBarWrapper from 'trade-in/components/TradeInBarWrapper/TradeInBarWrapper.jsx';
import TradeInTiles from 'trade-in/components/TradeInTiles/TradeInTiles.jsx';

import en from 'trade-in/i18n/en.json';
import fr from 'trade-in/i18n/fr.json';

const root = TradeInWrapper;
const provider = TradeInProvider;
const main = provider;

const i18n = {
    en,
    fr,
};

export const widgets = {
    TradeIn: {
        components: {
            root,
            main,
            provider,
            TradeInBarWrapper,
            TradeInTiles,
        },
        i18n,
        InstantEstimateProvider,
        OfficialTradeInProvider,
    },
};

export default {
    TradeIn: main,
    Translations: i18n,
    root,
    provider,
    InstantEstimateProvider,
    OfficialTradeInProvider,
    components: {
        TradeInBarWrapper,
        TradeInTiles,
    },
};



// WEBPACK FOOTER //
// ./src/index.js